import React, { memo, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Checkbox from '../../../../components/form/Checkbox';

import './AgencyAssignOTBypassModal.scss';

const AgencyAssignOTBypassModal = ({ handleOTBypassCancel, handleOTBypassAssign, caregiverName }) => {
	const [cond1Checked, setCond1Checked] = useState(false);
	const [cond2Checked, setCond2Checked] = useState(false);

	return (
		<Modal size="lg" show className="assign-OT-bypass-modal no-gutters" onHide={handleOTBypassCancel}>
			<Modal.Header closeButton>
				<Modal.Title>
					<span>Overtime Warning!</span>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="assign-OT-bypass-modal__acknowledgement">
					<Checkbox
						id="cond1-acknowledgment"
						className="assign-OT-bypass-modal__acknowledgement-checkbox"
						handleChange={(status) => setCond1Checked(status)}
					/>
					<label htmlFor="cond1-acknowledgment">
						I understand assigning this shift to {caregiverName}, can result in them working more than 40 hours in an
						invoiceable period within this specific management company’s facilities.
					</label>
				</div>
				<div className="assign-OT-bypass-modal__acknowledgement">
					<Checkbox
						id="cond2-acknowledgment"
						className="assign-OT-bypass-modal__acknowledgement-checkbox"
						handleChange={(status) => setCond2Checked(status)}
					/>
					{/* eslint-disable jsx-a11y/label-has-associated-control */}
					<label htmlFor="cond2-acknowledgment">
						I acknowledge that this management company refuses to pay for overtime. I want to proceed and assign my
						professional knowing that any overtime hours at this management company will be invoiced at the regular rate
						of this shift.
					</label>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={handleOTBypassCancel} variant="tertiary" disabled={false}>
					Cancel
				</Button>
				<Button
					variant="primary"
					disabled={!(cond1Checked && cond2Checked)}
					className="no-gutters"
					onClick={handleOTBypassAssign}
				>
					Assign professional
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default memo(AgencyAssignOTBypassModal);
